import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { BsArrowRight, BsCurrencyDollar } from "react-icons/bs";
import { Link } from "react-router-dom";

import {
  CollectionsHeading,
  MainTopCollections,
  CollectionsTable,
  BtnContainer,
} from "./element";
import check from "../../assets/check.png";
import ethlogo from "../../assets/eth-logo.png";
import { Buttons } from "components/common";
import { useEffect, useState } from "react";
import { GetCollectionsHook } from "hooks";
import { useNavigate } from "react-router-dom";

function TopCollections() {
  const navigate = useNavigate();
  const [hover, setHover] = useState(false);

  const { data, loading, error, getCollections } = GetCollectionsHook();

  useEffect(() => {
    getCollections("volume24h", 10);
  }, []);

  const handleMouseOver = () => {
    setHover(true);
  };

  const handleMouseOut = () => {
    setHover(false);
  };
  return (
    <MainTopCollections>
      <CollectionsHeading
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ delay: 0.15, duration: 1 }}
      >
        Top Collections Today
      </CollectionsHeading>
      <CollectionsTable
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ delay: 0.15, duration: 1 }}
      >
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell>Collection</TableCell>
                <TableCell align="right">24h vol</TableCell>
                <TableCell align="right">Total vol</TableCell>
                <TableCell align="right">Owners</TableCell>
                <TableCell align="right">Items</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data?.map((row) => (
                <TableRow key={row.Collection}>
                  <TableCell component="th" scope="row">
                    <img
                      className="img-fluid me-3"
                      width={40}
                      alt=""
                      src={row.logo}
                    />
                    <p onClick={() => navigate(`/collection/${row?._id}`)}>
                      {row.name}
                    </p>

                    <img className="img-fluid" alt="" src={check} />
                  </TableCell>
                  <TableCell align="right">
                    <BsCurrencyDollar style={{ marginBottom: "3px" }} />

                    {row.volume24h}
                    <br />
                    <span>{row.volumeDiff}%</span>
                  </TableCell>
                  <TableCell align="right">
                    <BsCurrencyDollar style={{ marginBottom: "3px" }} />
                    {row.totalVolume}
                    <br />
                  </TableCell>
                  <TableCell align="right">{row.owners}</TableCell>
                  <TableCell align="right">{row.items?.length}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </CollectionsTable>
      <BtnContainer>
        <Link to="/collection-all">
          <Buttons
            explore
            onMouseOver={handleMouseOver}
            onMouseOut={handleMouseOut}
          >
            See all collections{" "}
            {hover && <BsArrowRight style={{ marginTop: "3px" }} />}
          </Buttons>
        </Link>
      </BtnContainer>
    </MainTopCollections>
  );
}

export default TopCollections;
